import { Box } from '@mui/material'
import React, { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { SwitchField } from 'shared/ui'
import { AdvancedScheduling } from 'shared/ui/Schedule/ui/AdvancedScheduling'
import { SendingHours } from 'shared/ui/Schedule/ui/SendingHours'
import { DateEndTime } from '../../DateEndTime/DateEndTime'
import { useSendLaterContext } from '../context/sendLaterContext'

export type ISendLaterContentProps = {
  dropdownId?: string
}

export const SendLaterContent = observer(({ dropdownId }: ISendLaterContentProps) => {
  const {
    initDefault,
    advancedSchedulingStore,
    sendingHoursStore,
    toggleUseContactTimezone,
    isUseContactTimezone,
    isUseContactTimezoneDisabled,
    date,
    setDate,
    dropdownId: storeDropdownId,
    defaultDate,
  } = useSendLaterContext()

  useEffect(initDefault, [])
  return (
    <>
      <Box
        padding={1}
        borderBottom={'1px solid var(--border-neutral-default)'}
        display={'grid'}
        gap={'4px'}
      >
        <DateEndTime
          date={date}
          defaultDate={defaultDate}
          setDate={setDate}
          dropdownId={dropdownId || storeDropdownId}
        />
      </Box>

      {sendingHoursStore && (
        <SendingHours
          store={sendingHoursStore}
          expandedBoxProps={{
            borderBottom: '1px solid var(--border-neutral-default)',
          }}
        />
      )}

      <Box padding={1} borderBottom={'1px solid var(--border-neutral-default)'}>
        <SwitchField
          value={isUseContactTimezone}
          onClick={toggleUseContactTimezone}
          switchProps={{
            disabled: isUseContactTimezoneDisabled,
            tooltipProps: {
              width: 166,
              visibility: isUseContactTimezoneDisabled ? 'visible' : 'hidden',
              label: 'Disabled when “Restrict sending hours” is active',
              placement: 'bottom',
            },
          }}
          labelProps={{
            label: {
              leftIcon: 'userFilled',
              text: 'Use contact timezone',
            },
            questionTooltipProps: {
              label:
                "Sends messages based on the contact's time zone, determined by their phone number's area code.",
              width: 240,
              breakWord: true,
            },
          }}
        />
      </Box>
      {advancedSchedulingStore && (
        <AdvancedScheduling
          withoutTimePicker
          store={advancedSchedulingStore}
          expandedBoxProps={{
            borderRadius: '0 0 8px 8px',
          }}
        />
      )}
    </>
  )
})
